require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.repeat");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.reduce");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./cljs.spec.alpha.js");

require("./com.fulcrologic.guardrails.core.js");

require("./com.wsscode.misc.coll.js");

require("./com.wsscode.misc.refs.js");

require("./edn_query_language.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.pathom3.format.shape_descriptor.js");
goog.provide('com.wsscode.pathom3.format.shape_descriptor');
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433), cljs.core.list(new cljs.core.Symbol("cljs.spec.alpha", "map-of", "cljs.spec.alpha/map-of", 153715093, null), new cljs.core.Symbol("cljs.core", "any?", "cljs.core/any?", -2068111842, null), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433)), cljs.spec.alpha.every_impl.cljs$core$IFn$_invoke$arity$4(cljs.core.list(new cljs.core.Symbol("cljs.spec.alpha", "tuple", "cljs.spec.alpha/tuple", -415901908, null), new cljs.core.Symbol(null, "any?", "any?", -318999933, null), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433)), cljs.spec.alpha.tuple_impl.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol("cljs.core", "any?", "cljs.core/any?", -2068111842, null), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433)], null), new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [cljs.core.any_QMARK_, new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433)], null)), new cljs.core.PersistentArrayMap(null, 7, [new cljs.core.Keyword("cljs.spec.alpha", "kfn", "cljs.spec.alpha/kfn", 672643897), function (i__14248__auto__, v__14249__auto__) {
  return cljs.core.nth.cljs$core$IFn$_invoke$arity$2(v__14249__auto__, 0);
}, new cljs.core.Keyword(null, "into", "into", -150836029), cljs.core.PersistentArrayMap.EMPTY, new cljs.core.Keyword("cljs.spec.alpha", "conform-all", "cljs.spec.alpha/conform-all", 45201917), true, new cljs.core.Keyword(null, "kind", "kind", -717265803), cljs.core.map_QMARK_, new cljs.core.Keyword("cljs.spec.alpha", "kind-form", "cljs.spec.alpha/kind-form", -1047104697), new cljs.core.Symbol("cljs.core", "map?", "cljs.core/map?", -1390345523, null), new cljs.core.Keyword("cljs.spec.alpha", "describe", "cljs.spec.alpha/describe", 1883026911), cljs.core.list(new cljs.core.Symbol("cljs.spec.alpha", "map-of", "cljs.spec.alpha/map-of", 153715093, null), new cljs.core.Symbol("cljs.core", "any?", "cljs.core/any?", -2068111842, null), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433)), new cljs.core.Keyword("cljs.spec.alpha", "cpred", "cljs.spec.alpha/cpred", -693471218), function (G__33621) {
  return cljs.core.map_QMARK_(G__33621);
}], null), null));
/**
 * Deep merge of shapes, it takes in account that values are always maps.
 */

com.wsscode.pathom3.format.shape_descriptor.merge_shapes = function com$wsscode$pathom3$format$shape_descriptor$merge_shapes(var_args) {
  var G__33623 = arguments.length;

  switch (G__33623) {
    case 1:
      return com.wsscode.pathom3.format.shape_descriptor.merge_shapes.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return com.wsscode.pathom3.format.shape_descriptor.merge_shapes.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.pathom3.format.shape_descriptor.merge_shapes.cljs$core$IFn$_invoke$arity$1 = function (a) {
  return a;
};

com.wsscode.pathom3.format.shape_descriptor.merge_shapes.cljs$core$IFn$_invoke$arity$2 = function (a, b) {
  if (cljs.core.map_QMARK_(a) && cljs.core.map_QMARK_(b)) {
    return cljs.core.with_meta(cljs.core.merge_with.cljs$core$IFn$_invoke$arity$variadic(com.wsscode.pathom3.format.shape_descriptor.merge_shapes, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a, b], 0)), cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([cljs.core.meta(a), cljs.core.meta(b)], 0)));
  } else {
    if (cljs.core.map_QMARK_(a)) {
      return a;
    } else {
      if (cljs.core.map_QMARK_(b)) {
        return b;
      } else {
        return b;
      }
    }
  }
};

com.wsscode.pathom3.format.shape_descriptor.merge_shapes.cljs$lang$maxFixedArity = 2;
/**
 * Helper function to transform a map into an shape descriptor.
 * 
 *   Edges of shape descriptor are always an empty map. If a value of the map is a sequence.
 *   This will combine the keys present in all items on the final shape description.
 * 
 *   WARN: this idea of merging is still under test, this may change in the future.
 */

com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor = function com$wsscode$pathom3$format$shape_descriptor$data__GT_shape_descriptor(data) {
  if (cljs.core.map_QMARK_(data)) {
    return cljs.core.reduce_kv(function (out, k, v) {
      return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, cljs.core.map_QMARK_(v) ? com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor.cljs$core$IFn$_invoke$arity$1(v) : com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor.call(null, v) : cljs.core.sequential_QMARK_(v) ? function () {
        var shape = cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (q, x) {
          return com.wsscode.misc.coll.merge_grow.cljs$core$IFn$_invoke$arity$2(q, com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor.cljs$core$IFn$_invoke$arity$1(x) : com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor.call(null, x));
        }, cljs.core.PersistentArrayMap.EMPTY, v);

        if (cljs.core.seq(shape)) {
          return shape;
        } else {
          return cljs.core.PersistentArrayMap.EMPTY;
        }
      }() : cljs.core.PersistentArrayMap.EMPTY);
    }, cljs.core.PersistentArrayMap.EMPTY, data);
  } else {
    return null;
  }
};
/**
 * Like data->shape-descriptor, but only at the root keys of the data.
 */


com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor_shallow = function com$wsscode$pathom3$format$shape_descriptor$data__GT_shape_descriptor_shallow(data) {
  return cljs.core.zipmap(cljs.core.keys(data), cljs.core.repeat.cljs$core$IFn$_invoke$arity$1(cljs.core.PersistentArrayMap.EMPTY));
};

com.wsscode.pathom3.format.shape_descriptor.shape_params = function com$wsscode$pathom3$format$shape_descriptor$shape_params(shape_value, params) {
  return cljs.core.vary_meta.cljs$core$IFn$_invoke$arity$4(shape_value, cljs.core.assoc, new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "params", "com.wsscode.pathom3.format.shape-descriptor/params", -1116912186), params);
};
/**
 * Convert EQL AST to shape descriptor format.
 */


com.wsscode.pathom3.format.shape_descriptor.ast__GT_shape_descriptor = function com$wsscode$pathom3$format$shape_descriptor$ast__GT_shape_descriptor(ast) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (m, p__33624) {
    var map__33625 = p__33624;
    var map__33625__$1 = (!(map__33625 == null) ? map__33625.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__33625.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__33625) : map__33625;
    var node = map__33625__$1;
    var key = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33625__$1, new cljs.core.Keyword(null, "key", "key", -1516042587));
    var type = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33625__$1, new cljs.core.Keyword(null, "type", "type", 1174270348));
    var children = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33625__$1, new cljs.core.Keyword(null, "children", "children", -940561982));
    var params = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33625__$1, new cljs.core.Keyword(null, "params", "params", 710516235));

    if (com.wsscode.misc.refs.kw_identical_QMARK_(new cljs.core.Keyword(null, "union", "union", 2142937499), type)) {
      var unions = cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentVector.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(com.wsscode.pathom3.format.shape_descriptor.ast__GT_shape_descriptor), children);
      return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(com.wsscode.pathom3.format.shape_descriptor.merge_shapes, m, unions);
    } else {
      return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m, key, function () {
        var G__33627 = com.wsscode.pathom3.format.shape_descriptor.ast__GT_shape_descriptor.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.pathom3.format.shape_descriptor.ast__GT_shape_descriptor.cljs$core$IFn$_invoke$arity$1(node) : com.wsscode.pathom3.format.shape_descriptor.ast__GT_shape_descriptor.call(null, node);

        if (cljs.core.seq(params)) {
          return com.wsscode.pathom3.format.shape_descriptor.shape_params(G__33627, params);
        } else {
          return G__33627;
        }
      }());
    }
  }, cljs.core.PersistentArrayMap.EMPTY, new cljs.core.Keyword(null, "children", "children", -940561982).cljs$core$IFn$_invoke$arity$1(ast));
};
/**
 * Convert pathom output format into shape descriptor format.
 */


com.wsscode.pathom3.format.shape_descriptor.query__GT_shape_descriptor = function com$wsscode$pathom3$format$shape_descriptor$query__GT_shape_descriptor(output) {
  return com.wsscode.pathom3.format.shape_descriptor.ast__GT_shape_descriptor(edn_query_language.core.query__GT_ast(output));
};
/**
 * Convert pathom output format into shape descriptor format.
 */


com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast_children = function com$wsscode$pathom3$format$shape_descriptor$shape_descriptor__GT_ast_children(shape) {
  var union_QMARK_ = new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "union?", "com.wsscode.pathom3.format.shape-descriptor/union?", -702499972).cljs$core$IFn$_invoke$arity$1(cljs.core.meta(shape));

  if (cljs.core.truth_(union_QMARK_)) {
    return new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "union", "union", 2142937499), new cljs.core.Keyword(null, "children", "children", -940561982), cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentVector.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (p__33628) {
      var vec__33629 = p__33628;
      var uk = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__33629, 0, null);
      var uv = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__33629, 1, null);
      return new cljs.core.PersistentArrayMap(null, 3, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "union-entry", "union-entry", 223335750), new cljs.core.Keyword(null, "union-key", "union-key", 1529707234), uk, new cljs.core.Keyword(null, "children", "children", -940561982), com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast_children.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast_children.cljs$core$IFn$_invoke$arity$1(uv) : com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast_children.call(null, uv)], null);
    }), shape)], null)], null);
  } else {
    return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentVector.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (p__33632) {
      var vec__33633 = p__33632;
      var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__33633, 0, null);
      var v = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__33633, 1, null);
      var params = new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "params", "com.wsscode.pathom3.format.shape-descriptor/params", -1116912186).cljs$core$IFn$_invoke$arity$1(cljs.core.meta(v));
      var G__33636 = new cljs.core.PersistentArrayMap(null, 3, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "prop", "prop", -515168332), new cljs.core.Keyword(null, "key", "key", -1516042587), k, new cljs.core.Keyword(null, "dispatch-key", "dispatch-key", 733619510), k], null);
      var G__33636__$1 = cljs.core.seq(v) ? cljs.core.assoc.cljs$core$IFn$_invoke$arity$variadic(G__33636, new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "join", "join", -758861890), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword(null, "children", "children", -940561982), com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast_children.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast_children.cljs$core$IFn$_invoke$arity$1(v) : com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast_children.call(null, v)], 0)) : G__33636;

      if (cljs.core.seq(params)) {
        return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(G__33636__$1, new cljs.core.Keyword(null, "params", "params", 710516235), params);
      } else {
        return G__33636__$1;
      }
    }), shape);
  }
};
/**
 * Convert pathom output format into shape descriptor format.
 */


com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast = function com$wsscode$pathom3$format$shape_descriptor$shape_descriptor__GT_ast(shape) {
  return new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "root", "root", -448657453), new cljs.core.Keyword(null, "children", "children", -940561982), com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast_children(shape)], null);
};
/**
 * Convert pathom output format into shape descriptor format.
 */


com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_query = function com$wsscode$pathom3$format$shape_descriptor$shape_descriptor__GT_query(shape) {
  var union_QMARK_ = new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "union?", "com.wsscode.pathom3.format.shape-descriptor/union?", -702499972).cljs$core$IFn$_invoke$arity$1(cljs.core.meta(shape));
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.truth_(union_QMARK_) ? cljs.core.PersistentArrayMap.EMPTY : cljs.core.PersistentVector.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (p__33637) {
    var vec__33638 = p__33637;
    var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__33638, 0, null);
    var v = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__33638, 1, null);
    var params = new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "params", "com.wsscode.pathom3.format.shape-descriptor/params", -1116912186).cljs$core$IFn$_invoke$arity$1(cljs.core.meta(v));
    var G__33641 = cljs.core.truth_(function () {
      var or__4126__auto__ = cljs.core.seq(v);

      if (or__4126__auto__) {
        return or__4126__auto__;
      } else {
        return union_QMARK_;
      }
    }()) ? cljs.core.PersistentArrayMap.createAsIfByAssoc([k, com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_query.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_query.cljs$core$IFn$_invoke$arity$1(v) : com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_query.call(null, v)]) : k;

    if (cljs.core.seq(params)) {
      return new cljs.core.List(null, G__33641, new cljs.core.List(null, params, null, 1, null), 2, null);
    } else {
      return G__33641;
    }
  }), shape);
};
/**
 * This helper will remove nested requirements when data is an empty collection. This
 *   allows for nested inputs with empty collections to still be valid in shape.
 */


com.wsscode.pathom3.format.shape_descriptor.relax_empty_collections = function com$wsscode$pathom3$format$shape_descriptor$relax_empty_collections(required, data) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (r, p__33642) {
    var vec__33643 = p__33642;
    var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__33643, 0, null);
    var v = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__33643, 1, null);

    if (cljs.core.contains_QMARK_(r, k) && com.wsscode.misc.coll.collection_QMARK_(v) && cljs.core.empty_QMARK_(v)) {
      return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(r, k, cljs.core.PersistentArrayMap.EMPTY);
    } else {
      if (cljs.core.contains_QMARK_(r, k) && cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(cljs.core.get.cljs$core$IFn$_invoke$arity$2(r, k), cljs.core.PersistentArrayMap.EMPTY)) {
        return cljs.core.update.cljs$core$IFn$_invoke$arity$4(r, k, com.wsscode.pathom3.format.shape_descriptor.relax_empty_collections, v);
      } else {
        return r;
      }
    }
  }, required, cljs.core.map_QMARK_(data) ? data : com.wsscode.misc.coll.collection_QMARK_(data) ? cljs.core.first(data) : null);
};
/**
 * Given some available and required shapes, returns which items are missing from available
 *   in the required. Returns nil when nothing is missing.
 */


com.wsscode.pathom3.format.shape_descriptor.missing = function com$wsscode$pathom3$format$shape_descriptor$missing(var_args) {
  var G__33647 = arguments.length;

  switch (G__33647) {
    case 2:
      return com.wsscode.pathom3.format.shape_descriptor.missing.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return com.wsscode.pathom3.format.shape_descriptor.missing.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.pathom3.format.shape_descriptor.missing.cljs$core$IFn$_invoke$arity$2 = function (available_shape, required_shape) {
  var res = cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentArrayMap.EMPTY, cljs.core.keep.cljs$core$IFn$_invoke$arity$1(function (el) {
    var attr = cljs.core.key(el);
    var sub_query = cljs.core.val(el);

    if (cljs.core.contains_QMARK_(available_shape, attr)) {
      var temp__5802__auto__ = function () {
        var and__4115__auto__ = cljs.core.seq(sub_query);

        if (and__4115__auto__) {
          return com.wsscode.pathom3.format.shape_descriptor.missing.cljs$core$IFn$_invoke$arity$2(cljs.core.get.cljs$core$IFn$_invoke$arity$2(available_shape, attr), sub_query);
        } else {
          return and__4115__auto__;
        }
      }();

      if (cljs.core.truth_(temp__5802__auto__)) {
        var sub_req = temp__5802__auto__;
        return com.wsscode.misc.coll.make_map_entry(attr, sub_req);
      } else {
        return null;
      }
    } else {
      return el;
    }
  }), required_shape);

  if (cljs.core.seq(res)) {
    return res;
  } else {
    return null;
  }
};

com.wsscode.pathom3.format.shape_descriptor.missing.cljs$core$IFn$_invoke$arity$3 = function (available, required, data) {
  return com.wsscode.pathom3.format.shape_descriptor.missing.cljs$core$IFn$_invoke$arity$2(available, com.wsscode.pathom3.format.shape_descriptor.relax_empty_collections(required, data));
};

com.wsscode.pathom3.format.shape_descriptor.missing.cljs$lang$maxFixedArity = 3;
/**
 * Like missing, but starts from data instead of shape. If you are starting from data
 *   prefer this over missing, this can perform better by avoiding scanning the whole
 *   available data to build a shape, when the required-shape is a sub-set of the available
 *   data.
 */

com.wsscode.pathom3.format.shape_descriptor.missing_from_data = function com$wsscode$pathom3$format$shape_descriptor$missing_from_data(available_data, required_shape) {
  var res = cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentArrayMap.EMPTY, cljs.core.keep.cljs$core$IFn$_invoke$arity$1(function (el) {
    var attr = cljs.core.key(el);
    var sub_shape = cljs.core.val(el);
    var sub_value = cljs.core.get.cljs$core$IFn$_invoke$arity$2(available_data, attr);

    if (cljs.core.contains_QMARK_(available_data, attr)) {
      if (cljs.core.seq(sub_shape)) {
        if (com.wsscode.misc.coll.collection_QMARK_(sub_value)) {
          var shape = cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(com.wsscode.pathom3.format.shape_descriptor.merge_shapes, cljs.core.PersistentArrayMap.EMPTY, cljs.core.mapv.cljs$core$IFn$_invoke$arity$2(function (p1__33648_SHARP_) {
            return com.wsscode.pathom3.format.shape_descriptor.missing_from_data.cljs$core$IFn$_invoke$arity$2 ? com.wsscode.pathom3.format.shape_descriptor.missing_from_data.cljs$core$IFn$_invoke$arity$2(p1__33648_SHARP_, sub_shape) : com.wsscode.pathom3.format.shape_descriptor.missing_from_data.call(null, p1__33648_SHARP_, sub_shape);
          }, sub_value));

          if (cljs.core.seq(shape)) {
            return com.wsscode.misc.coll.make_map_entry(attr, shape);
          } else {
            return null;
          }
        } else {
          var temp__5802__auto__ = com.wsscode.pathom3.format.shape_descriptor.missing_from_data.cljs$core$IFn$_invoke$arity$2 ? com.wsscode.pathom3.format.shape_descriptor.missing_from_data.cljs$core$IFn$_invoke$arity$2(sub_value, sub_shape) : com.wsscode.pathom3.format.shape_descriptor.missing_from_data.call(null, sub_value, sub_shape);

          if (cljs.core.truth_(temp__5802__auto__)) {
            var sub_req = temp__5802__auto__;
            return com.wsscode.misc.coll.make_map_entry(attr, sub_req);
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    } else {
      return el;
    }
  }), required_shape);

  if (cljs.core.seq(res)) {
    return res;
  } else {
    return null;
  }
};
/**
 * Like set/difference, for shapes.
 */


com.wsscode.pathom3.format.shape_descriptor.difference = function com$wsscode$pathom3$format$shape_descriptor$difference(s1, s2) {
  return cljs.core.reduce_kv(function (out, k, sub) {
    var temp__5802__auto__ = cljs.core.find(s2, k);

    if (cljs.core.truth_(temp__5802__auto__)) {
      var x = temp__5802__auto__;
      var v = cljs.core.val(x);

      if (cljs.core.seq(sub) && cljs.core.seq(v)) {
        var sub_diff = com.wsscode.pathom3.format.shape_descriptor.difference.cljs$core$IFn$_invoke$arity$2 ? com.wsscode.pathom3.format.shape_descriptor.difference.cljs$core$IFn$_invoke$arity$2(sub, v) : com.wsscode.pathom3.format.shape_descriptor.difference.call(null, sub, v);

        if (cljs.core.seq(sub_diff)) {
          return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, sub_diff);
        } else {
          return out;
        }
      } else {
        return out;
      }
    } else {
      return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, sub);
    }
  }, function () {
    var or__4126__auto__ = cljs.core.empty(s1);

    if (cljs.core.truth_(or__4126__auto__)) {
      return or__4126__auto__;
    } else {
      return cljs.core.PersistentArrayMap.EMPTY;
    }
  }(), s1);
};
/**
 * Like set/intersection, for shapes.
 */


com.wsscode.pathom3.format.shape_descriptor.intersection = function com$wsscode$pathom3$format$shape_descriptor$intersection(s1, s2) {
  return cljs.core.reduce_kv(function (out, k, sub) {
    var temp__5802__auto__ = cljs.core.find(s2, k);

    if (cljs.core.truth_(temp__5802__auto__)) {
      var x = temp__5802__auto__;
      var v = cljs.core.val(x);
      var meta = cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([cljs.core.meta(sub), cljs.core.meta(v)], 0));

      if (cljs.core.seq(sub) && cljs.core.seq(v)) {
        var sub_inter = com.wsscode.pathom3.format.shape_descriptor.intersection.cljs$core$IFn$_invoke$arity$2 ? com.wsscode.pathom3.format.shape_descriptor.intersection.cljs$core$IFn$_invoke$arity$2(sub, v) : com.wsscode.pathom3.format.shape_descriptor.intersection.call(null, sub, v);

        if (cljs.core.seq(sub_inter)) {
          return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, cljs.core.with_meta(sub_inter, meta));
        } else {
          return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, cljs.core.with_meta(cljs.core.PersistentArrayMap.EMPTY, meta));
        }
      } else {
        return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, cljs.core.with_meta(cljs.core.PersistentArrayMap.EMPTY, meta));
      }
    } else {
      return out;
    }
  }, function () {
    var or__4126__auto__ = cljs.core.empty(s1);

    if (cljs.core.truth_(or__4126__auto__)) {
      return or__4126__auto__;
    } else {
      return cljs.core.PersistentArrayMap.EMPTY;
    }
  }(), s1);
};
/**
 * Select the parts of data covered by shape. This is similar to select-keys, but for
 *   nested shapes.
 */


com.wsscode.pathom3.format.shape_descriptor.select_shape = function com$wsscode$pathom3$format$shape_descriptor$select_shape(data, shape) {
  return cljs.core.reduce_kv(function (out, k, sub) {
    var temp__5802__auto__ = cljs.core.find(data, k);

    if (cljs.core.truth_(temp__5802__auto__)) {
      var x = temp__5802__auto__;
      var v = cljs.core.val(x);

      if (cljs.core.seq(sub)) {
        if (cljs.core.map_QMARK_(v)) {
          return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, com.wsscode.pathom3.format.shape_descriptor.select_shape.cljs$core$IFn$_invoke$arity$2 ? com.wsscode.pathom3.format.shape_descriptor.select_shape.cljs$core$IFn$_invoke$arity$2(v, sub) : com.wsscode.pathom3.format.shape_descriptor.select_shape.call(null, v, sub));
        } else {
          if (com.wsscode.misc.coll.collection_QMARK_(v)) {
            return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.empty(v), cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (p1__33649_SHARP_) {
              return com.wsscode.pathom3.format.shape_descriptor.select_shape.cljs$core$IFn$_invoke$arity$2 ? com.wsscode.pathom3.format.shape_descriptor.select_shape.cljs$core$IFn$_invoke$arity$2(p1__33649_SHARP_, sub) : com.wsscode.pathom3.format.shape_descriptor.select_shape.call(null, p1__33649_SHARP_, sub);
            }), v));
          } else {
            return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, v);
          }
        }
      } else {
        return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, v);
      }
    } else {
      return out;
    }
  }, cljs.core.empty(data), shape);
};

com.wsscode.pathom3.format.shape_descriptor.select_shape_filter_coll = function com$wsscode$pathom3$format$shape_descriptor$select_shape_filter_coll(out, k, v, sub, sub_req) {
  var sub_keys = cljs.core.keys(sub_req);
  return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.empty(v), cljs.core.keep.cljs$core$IFn$_invoke$arity$1(function (p1__33650_SHARP_) {
    var s_SINGLEQUOTE_ = com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.cljs$core$IFn$_invoke$arity$3 ? com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.cljs$core$IFn$_invoke$arity$3(p1__33650_SHARP_, sub, sub_req) : com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.call(null, p1__33650_SHARP_, sub, sub_req);

    if (cljs.core.every_QMARK_(function (x) {
      return cljs.core.contains_QMARK_(s_SINGLEQUOTE_, x);
    }, sub_keys)) {
      return s_SINGLEQUOTE_;
    } else {
      return null;
    }
  }), v));
};
/**
 * Like select-shape, but in case of collections, if some item doesn't have all the
 *   required keys, its removed from the collection.
 */


com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering = function com$wsscode$pathom3$format$shape_descriptor$select_shape_filtering(var_args) {
  var G__33652 = arguments.length;

  switch (G__33652) {
    case 2:
      return com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.cljs$core$IFn$_invoke$arity$2 = function (data, shape) {
  return com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.cljs$core$IFn$_invoke$arity$3(data, shape, shape);
};

com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.cljs$core$IFn$_invoke$arity$3 = function (data, shape, required_shape) {
  return cljs.core.reduce_kv(function (out, k, sub) {
    var temp__5802__auto__ = cljs.core.find(data, k);

    if (cljs.core.truth_(temp__5802__auto__)) {
      var x = temp__5802__auto__;
      var v = cljs.core.val(x);

      if (cljs.core.seq(sub)) {
        var sub_req = cljs.core.get.cljs$core$IFn$_invoke$arity$2(required_shape, k);

        if (cljs.core.map_QMARK_(v)) {
          return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.cljs$core$IFn$_invoke$arity$3(v, sub, sub_req));
        } else {
          if (com.wsscode.misc.coll.collection_QMARK_(v)) {
            return com.wsscode.pathom3.format.shape_descriptor.select_shape_filter_coll(out, k, v, sub, sub_req);
          } else {
            return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, v);
          }
        }
      } else {
        return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, k, v);
      }
    } else {
      return out;
    }
  }, cljs.core.empty(data), shape);
};

com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering.cljs$lang$maxFixedArity = 3;
Object.defineProperty(module.exports, "missing", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.missing;
  }
});
Object.defineProperty(module.exports, "ast__GT_shape_descriptor", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.ast__GT_shape_descriptor;
  }
});
Object.defineProperty(module.exports, "data__GT_shape_descriptor_shallow", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor_shallow;
  }
});
Object.defineProperty(module.exports, "select_shape_filtering", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.select_shape_filtering;
  }
});
Object.defineProperty(module.exports, "intersection", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.intersection;
  }
});
Object.defineProperty(module.exports, "shape_params", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.shape_params;
  }
});
Object.defineProperty(module.exports, "data__GT_shape_descriptor", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.data__GT_shape_descriptor;
  }
});
Object.defineProperty(module.exports, "merge_shapes", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.merge_shapes;
  }
});
Object.defineProperty(module.exports, "shape_descriptor__GT_ast", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast;
  }
});
Object.defineProperty(module.exports, "query__GT_shape_descriptor", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.query__GT_shape_descriptor;
  }
});
Object.defineProperty(module.exports, "relax_empty_collections", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.relax_empty_collections;
  }
});
Object.defineProperty(module.exports, "missing_from_data", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.missing_from_data;
  }
});
Object.defineProperty(module.exports, "shape_descriptor__GT_query", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_query;
  }
});
Object.defineProperty(module.exports, "select_shape", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.select_shape;
  }
});
Object.defineProperty(module.exports, "shape_descriptor__GT_ast_children", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.shape_descriptor__GT_ast_children;
  }
});
Object.defineProperty(module.exports, "difference", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.difference;
  }
});
Object.defineProperty(module.exports, "select_shape_filter_coll", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.format.shape_descriptor.select_shape_filter_coll;
  }
});